<div class="row">
  <div class="col-12">

    <div class="container">
      <nav class="breadcrumb-container mb-4 mt-2" aria-label="Percorso di navigazione">
        <ol class="breadcrumb">
          <li class="breadcrumb-item">
            <a [routerLink]="'/'">Home</a><span class="separator">/</span>
          </li>
          <li class="breadcrumb-item"
              *ngFor="let breadcrumbItem of reversedHeap; index as i; last as isLast;"
              [ngClass]="{ 'active': isLast }"
              [attr.aria-current]="isLast ? 'page' : null"
          >
            <a
              href={{breadcrumbItem.routerLink}}
              (click)="navigateToBreadcrumbItem($event, breadcrumbItem, i)"
            >
              {{ breadcrumbItem.label }}
            </a>
            <span *ngIf="!isLast" class="separator">/</span>
          </li>
        </ol>
      </nav>
    </div>
  </div>
</div>
